import React, { } from "react";
import { useAppDispatch,useAppSelector } from "../../../app/hooks";
import {checkedAllState, unCheckedAllState, checkedState, unCheckedState, getAccountbreakByAccountbreakIdAsync, deleteAccountbreakAsync, updateAccountbreakAsync,updateSorting } from "./breakSlice";
import { Dropdown } from "react-bootstrap";
import { ShowSwalWithConfirmation } from "../../../common/SweetAlert";
import { ShowToast } from "../../../common/Toastr";
import { setItemStatus, getValueFromResource } from '../../../common/timeLiveFunction';

import clsx from 'clsx'
const itemClass = 'ms-1 ms-lg-0';
const BreakTypeItem = (props: any) => {
    const { breakList, onopenModal, t, IsEdit, IsDelete } = props;
    const { sortOrder, sortColumn, pageSize } = useAppSelector((state) => state.break);

    const dispatch = useAppDispatch();
    const handleCheckboxChange = (e: any, rowId: any) => {
        console.log('ID',checkedState(rowId) )
        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId));
        }
    };

    const onEditClick = (AccountBreakTypeId: number) => {
        dispatch(getAccountbreakByAccountbreakIdAsync(AccountBreakTypeId))
            .unwrap()
            .then((originalPromiseResult) => {
                onopenModal();
            })
            .catch((rejectedValueOrSerializedError) => {

            })
    }
    const onDeleteClick = (AccountBreakTypeId: number) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteAccountbreakAsync(AccountBreakTypeId))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            ShowToast("Break Type delete Successfully", 'Success', "success", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                        })
                }
            })
            .catch((error) => {

            });
    }
    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch
                (checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    };
    const handleIsDisabledChange = (e: any, Accountbreak: any) => {
        const { checked } = e.target;
        const foundIndex = breakList.findIndex((item: any) => item.AccountBreakTypeId === Accountbreak.AccountBreakTypeId);
        if (foundIndex !== -1) {
            const foundItem = breakList[foundIndex];
            const { isSelected,IsDeleted,AccountId,CreatedByEmployeeId,CreatedOn,ModifiedByEmployeeId,ModifiedOn, ...updatedItem } = foundItem;
            updatedItem.IsDisabled = checked;
            const modifiedList = [...breakList.slice(0, foundIndex), updatedItem, ...breakList.slice(foundIndex + 1)];
            dispatch(updateAccountbreakAsync(updatedItem))
                //.unwrap()
                .then((originalPromiseResult) => {
                    console.log("originalPromiseResult", originalPromiseResult)
                    ShowToast("Break Type Update Successfully", 'Success', "success", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
    };
    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "pageSize": pageSize,
            "pageNo": 1
        }));
    }

    return (
        <>
            
                <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                    <thead>
                        <tr className="thHeading align-middle "  >
                            {IsDelete &&
                                <th className='w-25px'>
                                    <div className='form-check form-check-sm form-check-custom  form-check-solid small-checkbox' >
                                        
                                        <input
                                            className='form-check-input'
                                            type='checkbox'
                                            checked={breakList.every((item: any) => item.isSelected === 0) ? false :
                                                (breakList.every((item: any) => item.isSelected === 1 ? true : false))
                                            }
                                           
                                            onChange={handleSelectAllChange}
                                        />
                                    </div>
                                </th>
                            }
                            <th style={{ width: '15%' }}>
                                {/* {t('Active / Inactive')} */}
                                {getValueFromResource('Active / Inactive',dispatch, t)}
                            {sortColumn === 'IsDisabled' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>                          
                        <th style={{ width: '70%' }}>
                            {/* {t('Break Type')} */}
                            {getValueFromResource('Break Type',dispatch, t)}
                            {sortColumn === 'BreakType' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "BreakType") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "BreakType") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "BreakType") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "BreakType") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>                            
                         
                            {/* {IsEdit &&
                                <th className='w-15'>{t('Active / Inactive')}</th>
                            } */}
                            <th className='w-10 text-center'></th>
                        </tr>
                    </thead>
                    <tbody>
                        {breakList.length > 0 && breakList.map((BreakDetails: any, i: any) => (
                            <tr key={i}>
                                {IsDelete &&
                                    <td>
                                        <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox'>
                                            <input
                                                type="checkbox"
                                                className="form-check-input widget-9-check "
                                                checked={BreakDetails.isSelected == 0 ? false : true}
                                                onChange={(e) => { handleCheckboxChange(e, BreakDetails.AccountBreakTypeId) }}
                                            />
                                        </div>
                                    </td>
                                }  
                                <td>
                                    <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(BreakDetails.IsDisabled === 'No' ? "Active" : "InActive"))}>
                                        {BreakDetails.IsDisabled === 'No' ? "Active" : "InActive"}
                                    </span>
                                </td>                             
                                <td className='text-gray-800  text-hover-primary custom-pointer-cursor '
                                    onClick={IsEdit ? () => onEditClick(BreakDetails.AccountBreakTypeId) : undefined}
                                >
                                    <span className="   d-block "
                                    >{BreakDetails.BreakType}</span>
                                </td>
                                {/* {IsEdit &&
                                    <td className='text-center'>
                                        <div className="form-check form-switch form-check-custom">
                                            <input
                                                type="checkbox"
                                                className="form-check-input custom-padding-right h-15px w-30px"
                                                id="IsDisabled"
                                                checked={BreakDetails.IsDisabled === 'Yes' ? true : false}
                                                onChange={(e) => { handleIsDisabledChange(e, BreakDetails) }}
                                            />
                                          
                                        </div>
                                    </td>
                                } */}
                                 <td className='text-center'>
                                <Dropdown
                                    style={{ marginLeft: 1 }}
                                    className={clsx('cursor-pointer symbol')}
                                    data-kt-menu-attach='parent'
                                    data-kt-menu-placement='bottom-end'
                                >
                                    <Dropdown.Toggle
                                        variant="transparent"
                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content=
                                        // {t("More")}
                                        {getValueFromResource('More',dispatch, t)}
                                        data-tooltip-place="top"
                                    >
                                        <i className="bi bi-three-dots fs-7"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                                {IsEdit &&
                                                    <>
                                                        <div className='menu-hover-bg-sec'>
                                                            <Dropdown.Item
                                                                className="menu-item me-lg-0 "
                                                                onClick={() => {
                                                                    dispatch(getAccountbreakByAccountbreakIdAsync(BreakDetails.AccountBreakTypeId))
                                                                        .unwrap()
                                                                        .then((originalPromiseResult) => {
                                                                            onopenModal();
                                                                        })
                                                                        .catch((rejectedValueOrSerializedError) => {
                                                                        })
                                                                }}
                                                            >
                                                                <span className="menu-icon custom-menu">
                                                                    <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title custom-menu-fontsize">
                                                                    {/* {`${t('Edit')}`} */}
                                                                    {getValueFromResource('Edit',dispatch, t)}
                                                                    </span>
                                                            </Dropdown.Item>
                                                        </div>
                                                    </>
                                                }
                                                {IsDelete && IsEdit &&
                                                    <div className='separator mb-1 mt-1 opacity-75 '></div>
                                                }
                                                {IsDelete &&
                                                    <>
                                                        <div className='menu-hover-bg-danger'>
                                                            <Dropdown.Item
                                                                className="menu-item me-lg-0 "
                                                                onClick={() => { onDeleteClick(BreakDetails.AccountBreakTypeId) }}>
                                                                <span className="menu-icon  custom-menu">
                                                                    <i className="bi bi-trash fs-6 delete-menu-icon-color allign" >
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title   delete-menu custom-menu-fontsize"  >
                                                                    {/* {`${t('Delete')}`} */}
                                                                    {getValueFromResource('Delete',dispatch, t)}
                                                                    </span>
                                                            </Dropdown.Item>
                                                        </div>
                                                    </>
                                                }
                                            </Dropdown.Menu>
                                        </Dropdown>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                             {breakList.length === 0 &&
                                    <div className=''>
                                        <p className='noDataFound'>
                                            {/* {t('No Record Found')} */}
                                            {getValueFromResource('No Record Found',dispatch, t)}
                                            </p>
                                    </div>
                                }


        </>
    )
}

export default BreakTypeItem